// extracted by mini-css-extract-plugin
export default {"benefits":"a2YzB","wrap":"b2YzB","external":"c2YzB","grid":"d2YzB","col":"e2YzB","button":"f2YzB"};